export const inventoryColorData1 = [
    {
      color:'#394A7E',
      name:'Amazon'
    },
    {
        color:'#4E6DCB',
        name:'Flipkart'
      },
      {
        color:'#20BF55',
        name:'Shopify'
      }
  ]
  export const OMSColorData = [
    {
      color:'#394A7E',
      name:'Amazon'
    },
    {
        color:'#4E6DCB',
        name:'Flipkart'
      },
      {
        color:'#20BF55',
        name:'Shopify'
      }
  ]
  export const DropShippingColorData = [
    {
      color:'#394A7E',
      name:'Amazon'
    },
    {
        color:'#4E6DCB',
        name:'Flipkart'
      },
      {
        color:'#20BF55',
        name:'Shopify'
      }
  ]
  export const CRMColorData = [
    {
      color:'#394A7E',
      name:'Amazon'
    },
    {
        color:'#4E6DCB',
        name:'Flipkart'
      },
      {
        color:'#20BF55',
        name:'Shopify'
      }
  ]
  export const BIColorData = [
    {
      color:'#394A7E',
      name:'Amazon'
    },
    {
        color:'#4E6DCB',
        name:'Flipkart'
      },
      {
        color:'#20BF55',
        name:'Shopify'
      }
  ]